<template>
  <GameGenresSelect v-model="valueModel" class="w-100 mb-3" />
</template>

<script>
import { emptyString, emptyObject } from '@/utils/factories';
import valueModel from '@/mixins/valueModel';
import GameGenresSelect from '@/components/form/GameGenresSelectBox';

export default {
  components: {
    GameGenresSelect,
  },
  mixins: [valueModel],

  props: {
    value: {
      type: Object,
      default: emptyObject,
    },
    label: {
      type: String,
      default: emptyString,
    },
  },
};
</script>

<style lang="scss"></style>
